import { ValuesType } from './helpers';

export const UserRoleTypes = {
    CompanyOwner: 'company_owner',
    BlockedClient: 'blocked_client',
    Vendor: 'vendor',
    Salesman: 'salesman',
    SandboxOwner: 'sandbox_owner',
} as const;

export type UserRole = ValuesType<typeof UserRoleTypes>;
// export type UserRoles = Array<UserRole>;
export type UserRoles = string[];

export interface User {
    id: number;
    email: string;
    full_name: string;
    name: string;
    last_time_uploaded: string;
    models_count: string;
    orders_count: string;
    phone_number: string;
    position: string;
    company_name: string;
    roles: UserRoles;
    send_notification?: boolean;
    surname: string;
}
